import { globalReducer } from '@dealstack/frontend/shared/mechanism/redux/reducers/global/global';
import { userReducer } from './user';
import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';

export const store = configureStore({
	reducer: { global: globalReducer, user: userReducer },
	enhancers: [Sentry.createReduxEnhancer({})],
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
